import { useState } from "react";
import styled from "styled-components";
import { colors } from "../../../../theme/color";
import { GET_ALL_USERS } from "../../../../graphql/queries/userManagement";
import { useQuery } from "@apollo/client";

const DropdownMainCon = styled.div`
  width: 100%;
  background: white;
  box-shadow: -5px 4px 30px 0px #bec4c940;
  border-radius: 5px;
  padding: 10px 0;
  border: 1px solid #e8eaed;
`;

const DropdownAdmin = styled.div`
  display: flex;
  align-items: center;
  width: 90%;
  margin: 0 auto;
  padding: 5px 0;
  cursor: pointer;
`;

const DropdownAdmins = styled.div`
  display: flex;
  align-items: center;
  width: 90%;
  margin: 0 auto;
  padding: 5px 0;
  cursor: pointer;
  color: #00c703;
`;

const AdminSpan = styled.span`
  text-align: center;
  font-size: 14px;
  font-size: 400;
  color: ${colors.NEUTRAL_NEUTRAL};
`;

const DropAdminX = styled.span`
  font-size: 18px;
  margin: 0 15px 0 10px;
`;

const DropAdminXspan = styled.span`
  font-size: 14px;
  font-weight: 400;
`;

const HorizontalLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  width: 100%;
  margin: 0 auto;
  padding-top: 10px;
  padding-bottom: 10px;
`;

const HorizontalSpan = styled.span`
  flex-grow: 1;
  height: 1px;
  background-color: #e8eaed;
`;

const RadioButton = styled.input.attrs({ type: "radio" })`
  margin-right: 15px;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  position: relative;

  &::before {
    content: "";
    display: inline-block;
    width: ${(props) => (props.checked ? "4px" : "16px")};
    height: ${(props) => (props.checked ? "4px" : "16px")};
    border: 2px solid ${(props) => (props.checked ? "#69c914" : "#CFCFCFCF")};
    border-radius: 50%;
    margin-right: 10px;
    vertical-align: middle;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    background-color: ${(props) => (props.checked ? "#CCF4CD" : "white")};
  }

  &::after {
    content: "";
    display: inline-block;
    width: 15px;
    height: 15px;
    border: 1px solid ${(props) => (props.checked ? "#69c914" : "#0056b3")};
    border-radius: 50%;
    vertical-align: middle;
    position: relative;
    z-index: 0;
    opacity: ${(props) => (props.checked ? "1" : "0")};
    background-color: ${(props) => (props.checked ? "#CCF4CD" : "white")};
  }

  &:checked::before {
    border-color: #69c914;
    background-color: #69c914;
  }
`;

export interface userContent {
  role: string;
}

const DropdownFilter = () => {
  const { loading, error, data } = useQuery(GET_ALL_USERS);
  const users = data?.getAllUsers || [];

  const [adminUser, setAdminUser] = useState(false);
  const [standardUser, setStandardUser] = useState(false);
  const [BasicUser, setBasicUser] = useState(false);
  const [filteredUsers, setFilteredUsers] = useState<userContent[]>([]);
  console.log("Filtered users:", filteredUsers);

  const handleFilter = (role: string) => {
    if (Array.isArray(users)) {
      const filteredArr = users.filter(
        (user: userContent) => user.role === role
      );
      setFilteredUsers(filteredArr);
    } else {
      setFilteredUsers([]);
    }
  };

  const handleAdminUser = () => {
    setAdminUser(true);
    setStandardUser(false);
    setBasicUser(false);
    handleFilter("Administrator");
  };

  const handleStandardUser = () => {
    setAdminUser(false);
    setStandardUser(true);
    setBasicUser(false);
    handleFilter("Standard User");
  };

  const handleBasicUser = () => {
    setAdminUser(false);
    setStandardUser(false);
    setBasicUser(true);
    handleFilter("Basic User");
  };

  return (
    <DropdownMainCon>
      <DropdownAdmin>
        <RadioButton checked={adminUser} onClick={handleAdminUser} />
        <AdminSpan>Administrator</AdminSpan>
      </DropdownAdmin>
      <HorizontalLine>
        <HorizontalSpan></HorizontalSpan>
      </HorizontalLine>
      <DropdownAdmin>
        <RadioButton checked={standardUser} onClick={handleStandardUser} />
        <AdminSpan>Standard User</AdminSpan>
      </DropdownAdmin>
      <HorizontalLine>
        <HorizontalSpan></HorizontalSpan>
      </HorizontalLine>
      <DropdownAdmin>
        <RadioButton checked={BasicUser} onClick={handleBasicUser} />
        <AdminSpan>Basic User</AdminSpan>
      </DropdownAdmin>

      {(adminUser || standardUser || BasicUser) && (
        <div>
          <HorizontalLine>
            <HorizontalSpan></HorizontalSpan>
          </HorizontalLine>
          <DropdownAdmins>
            <DropAdminX>x</DropAdminX>{" "}
            <DropAdminXspan>Clear Filter</DropAdminXspan>
          </DropdownAdmins>
        </div>
      )}
    </DropdownMainCon>
  );
};
export default DropdownFilter;
